import AudioControl from "./AudioControl";

export default AudioControl;